import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import { KpiDelta, KpiHeader, TileFooter, TileCard, } from '@cmd/ui-components';
import { useGetData, formatWholeNumber } from '@cmd/ui-utilities';
import { useIntl } from 'react-intl';
import { useSelector } from 'react-redux';
import { dateRangeSelector } from '../../../components/LandingPageHeader/LandingPageHeader';
import { organizationSelector } from '../../../state/orgIdState';
import transactionsApi, { TransactionsResource } from '../../../utils/apis/transactionsApiUtils';
import getFormattedGrossProfitData from './totalGrossProfitUtils';
import './TotalGrossProfit.scss';
const TotalGrossProfit = ({ 'data-testid': dataTestId }) => {
    const intl = useIntl();
    const testId = dataTestId ? `${dataTestId}-total-gross-profit` : 'ids-total-gross-profit';
    const orgId = useSelector(organizationSelector);
    const { startDate, endDate } = useSelector(dateRangeSelector);
    const LIMIT = 3;
    const params = {
        orgId,
        startDate,
        endDate,
        LIMIT,
    };
    const { data, isLoading, error } = useGetData(() => transactionsApi[TransactionsResource.GROSS_PROFIT].get(params), params, getFormattedGrossProfitData);
    const { grossProfit, deltas, lastUpdatedUTC, } = data || {};
    return (_jsx(TileCard, { title: intl.formatMessage({
            id: 'TOTAL_GROSS_PROFIT_TILE_TITLE',
            defaultMessage: 'Profit',
        }), description: intl.formatMessage({
            id: 'TOTAL_GROSS_PROFIT_TILE_DESC',
            defaultMessage: 'Total Gross Profit',
        }), className: "total-gross-profit", error: !!error, isLoading: isLoading, noData: (grossProfit || 0) === 0, "data-testid": testId ? `${testId}-widget-tile` : 'ids-widget-tile', footer: (_jsx(TileFooter, { sourceLabel: intl.formatMessage({
                id: 'SOURCE_VIN_SOLUTIONS',
                defaultMessage: 'VinSolutions',
            }), sourceLink: "https://www.vinsolutions.com", lastUpdated: new Date(lastUpdatedUTC || ''), "data-testid": testId })), children: _jsx(KpiHeader, { label: intl.formatMessage({
                id: 'TOTAL_GROSS_PROFIT_KPI_HEADER',
                defaultMessage: 'Gross Profit',
            }), value: grossProfit, kpiDeltas: (_jsx(_Fragment, { children: (deltas || []).map(({ period, value }) => (_jsx(KpiDelta, { deltaValue: value, period: period, "data-testid": testId }, `gross-profit-delta-${period}`))) })), valueFormatter: (val) => `$${formatWholeNumber(val)}`, "data-testid": testId }) }));
};
export default TotalGrossProfit;
